import { fabric } from 'fabric';
import Hammer from 'hammerjs';

export default fabric.util.createClass(fabric.Canvas, /** @lends fabric.Canvas.prototype */ {

  // Disable touch scroll when an element is selected
  selectionCreatedHandler(e) {
    fabric.util.setStyle(this.wrapperEl, {
      'touch-action': 'none',
    });
    fabric.util.setStyle(this.upperCanvasEl, {
      'touch-action': 'none',
    });
    fabric.util.setStyle(this.lowerCanvasEl, {
      'touch-action': 'none',
    });
  },
  // Re-Enable touch scroll when nothing is selected
  selectionClearedHandler(e) {
    fabric.util.setStyle(this.wrapperEl, {
      'touch-action': 'manipulation',
    });
    fabric.util.setStyle(this.upperCanvasEl, {
      'touch-action': 'manipulation',
    });
    fabric.util.setStyle(this.lowerCanvasEl, {
      'touch-action': 'manipulation',
    });
  },
  /**
       * Be sure that touchstart reacts to multitouch on hammerjs
       * @param e
       * @private
       */
  // eslint-disable-next-line
  _onMouseDown(e) {
    if (e.type === 'touchstart') {
      // Do not allow grouping in mobile mode
      this.selection = false;
      // eslint-disable-next-line
      fabric.util.removeListener(this.upperCanvasEl, 'mousedown', this._onMouseDown);
      if (this.currentTouchStart) {
        // Second event, stop this as this is multitouch
        clearTimeout(this.currentTouchStart);
        this.currentTouchStart = null;
      } else {
        // First touch start, wait 100 ms then call
        this.currentTouchStart = setTimeout(() => {
          this.currentTouchStart = null;
          this.callSuper('_onMouseDown', e);
        }, 75);
      }
    } else {
      this.callSuper('_onMouseDown', e);
    }
  },

  /**
       * mouseup delay has to be set as well
       * @param e
       * @private
       */
  // eslint-disable-next-line
  _onMouseUp(e) {
    if (e.type === 'touchend') {
      setTimeout(() => {
        this.callSuper('_onMouseUp', e);
      }, 75);
    } else {
      this.callSuper('_onMouseUp', e);
    }
  },

  // eslint-disable-next-line
  _onMouseMove(e) {
    // eslint-disable-next-line
    this.getActiveObject() && e.preventDefault && e.preventDefault();
    // eslint-disable-next-line
    this.__onMouseMove(e);
  },

  addOrRemove(functor, eventjsFunctor) {
    console.log('ADD OR REMOVE', { functor, eventjsFunctor });
    this.callSuper('addOrRemove', functor, eventjsFunctor);
    if (eventjsFunctor !== 'add') return;
    const mc = new Hammer.Manager(this.wrapperEl);

    // Create recognizers
    const Tap = new Hammer.Tap();
    const Pan = new Hammer.Pan({ pointers: 2 });
    const Pinch = new Hammer.Pinch();
    const Rotate = new Hammer.Rotate();
    const Press = new Hammer.Press({
      time: 500,
      pointers: 1,
    });

    Pinch.recognizeWith(Rotate);
    Pan.recognizeWith(Pinch);

    // add the recognizer
    mc.add(Tap);
    mc.add(Pinch);
    mc.add(Rotate);
    mc.add(Press);
    mc.add(Pan);

    // subscribe to events
    Object.keys(this.hammer).forEach((key) => {
      mc.on(key, this.hammer[key]);
    });
  },
});
